export function parseRouteParamToObject<T extends object>(
  value: string | null | undefined,
): T | null {
  try {
    return value ? (JSON.parse(value) as T) : null;
  } catch {
    return null;
  }
}
